export enum ParticipantEventStatus {
    MyEvent = "MyEvent",
    Joined = "Joined",
    Invited = "Invited",
    NotInvited = "NotInvited"
}